import { Country, Vehicle } from '../../utils/constants/values.constants';
import {
  SHOW_TARGET_PRICE,
  C2C_TARGET_PRICE_SHOW,
  AVG_MARKET_PRICE_SHOW,
  SHOW_DRIVER_MENU,
  SHOW_LOCATION_MENU,
  SHOW_MASTER_DATA_MENU,
  SHOW_VENDOR_ACTIVE,
  SHOW_MAKE,
  SHOW_INVENTORY_TYPE,
  SHOW_INVENTORY_SOURCE,
  SHOW_INVENTORY_SOURCE_IN_SEARCH,
  SHOW_INVENTORY_SOURCE_TYPE,
  SHOW_BULK_UPLOAD,
  SHOW_RESERVE_BUTTON,
  SPLIT_SLOT_TIME,
  SHOW_PIN_CODE_TAB,
  SHOW_INTERCITY_TAB,
  SHOW_INVENTORY_QR_CODE,
  SHOW_INSPECTION_TAB,
  SHOW_LISTING_PREVIEW_TAB,
  SHOW_INVENTORY_STAGE,
  SHOW_PARKING_SLOT,
  SHOW_RUNNING_CONDITION,
  APPEND_CITY_CODE,
  SHOW_OFFLINE_DRIVER_TYPES,
  SHOW_TOUCH_POINT_DROPDOWN,
  REMOVE_DEALER_DROPDOWN,
  GET_EXTERNAL_DELIVERY,
  SEARCH_INSPECTION_DETAILS,
  SHOW_BROKEN_CAR_MESSAGE,
  SHOW_CAR_BOOKED_CONFIRMATION,
  SHOW_PRICE_LOCK,
  RESTRICT_DATE,
  BLOCK_OUT_DELIVERY,
  SHOW_INVENTORY_OTHER_DETAILS_TAB,
  SEARCH_PAYMENT_STATUS,
  USE_SLOT_PLANNER,
  SHOW_CORPORATE_OFFICE,
  SHOW_PICKUP_CONTACT_ON_STOCKOUT,
  SHOW_DA_CONTACT_ON_STOCKOUT,
  SHOW_PICKUP_CONTACT_ON_PICKUP,
  SHOW_DA_CONTACT_ON_PICKUP,
  SHOW_KEY_MANAGEMENT_TAB,
  SHOW_CREATED_AT_FILTER,
  SHOW_HOW_TO_REACH,
  SHOW_SOLD,
  SHOW_OFFER_PRICE,
  SHOW_STOCKOUT_REASON_FILTER,
  SHOW_REGISTRATION_NUMBER,
  SHOW_ADDRESS_IN_THAI,
  SHOW_INVENTORY_SUBSTAGE,
  SHOW_INVENTORY_STAGE_REMARKS,
  SHOW_ROUND_TRIP_CHECK,
  HIDE_PINCODE_IN_ADDRESS,
  SHOW_EDIT_MOVEMENT,
  SHOW_ROAD_TAX,
  SHOW_ROAD_TAX_EXPIRY_DATE,
  SHOW_GPS_TRACKER_NO,
  SHOW_SOURCING_CANCELLATION,
  SHOW_DEALER_OPTIONAL,
  SHOW_PINCODE_FIELD,
  SHOW_PMS_FIELD,
  USE_BACK_DATED_PICKUP,
  SHOW_LOCUS_ID_IN_OFFLINE_VENDOR,
  SHOW_REASON_IN_OFFLINE_VENDOR,
  SHOW_COURTESY_CAR,
  SHOW_RIDER_PERSONA_ID,
  RESTRICT_ADDRESS_CHAR_COUNT,
  SHOW_STOCK_ID,
  SHOW_PARKED_DATE_FILTER,
  SHOW_LAST_PARKED_LOCATION_NAME,
  SHOW_LAST_PARKED_LOCATION_TYPE,
  SHOW_BULK_ACTION,
  SHOW_COMMENT_IN_MOVEMENT_CREATION,
  SHOW_VENDOR_TYPE_FILTER,
  SHOW_VENDOR_NAME_FILTER,
  DEFAULT_OPEN_INVENTORY_SEARCH,
  DEFAULT_OPEN_LOGISTIC_SEARCH,
  USE_FUZZY_SEARCH_IN_APT_ID,
  USE_FUZZY_SEARCH_IN_VIN,
  USE_FUZZY_SEARCH_IN_STOCK_ID,
  ENABLE_DATE_PICKER_SELECTION_BY_TYPING,
  SHOW_LOCALITY,
  SHOW_DELIVERED,
  SHOW_CONFIGURATIONS_MENU,
  SHOW_SCHEDULED_TASKS_MENU,
  SHOW_INVENTORY_TYPE_REMARKS,
  SHOW_DP_BANK_STATUS,
  SHOW_MAPPED_MRL,
  SHOW_ACCEPTING_INCOMING_LOGISTICS,
  SHOW_STORE_IMG_LINK,
  SHOW_BARCODE_IN_PARKING_SLOT,
  SHOW_PAYTM_WALLET,
  SHOW_REGIONAL_PAYTM_FUEL_WALLET,
  SHOW_ON_ROAD_PRICE,
  SHOW_MOVEMENT_TYPE_IN_SET_LOGISTICS,
  SHOW_RESERVED_STATUS,
  SHOW_CUSTOMER_RETURN,
  SHOW_SERVICEABLE_AREA,
  SHOW_ORDER_ID,
  SHOW_DRIVER_TYPE,
  SHOW_DRIVER_PAN,
  SHOW_USER_PREFERENCES_TAB,
  SHOW_ASSORTMENT_TYPE,
  SHOW_OFFLINE_DISCOUNT,
  SHOW_NUMBER_PLATE,
  SHOW_PARENT_HUB,
  SHOW_REASON_IN_AUDIT_TRAIL,
  SHOW_ADDITIONAL_REASONS,
  SHOW_INDIA_KEY_MANAGEMENT_TAB,
  SHOW_CATALOG_FLAG,
  SHOW_LOCATION_DISPLAY_NAME,
  SHOW_PSEUDO_STATUS,
  SHOW_CHASSIS_IMPRINT,
  SHOW_UPCOMING_STATUS,
  SHOW_INVENTORY_STATUS_REASON,
  SHOW_INVENTORY_SALE_CHANNEL,
} from './permission.type';

// Permission config example with all available verticals
/*
[PERMISSION_TYPE]: [
  { country: Country.KSA, vehicle: Vehicle.CAR },
  { country: Country.KSA, vehicle: Vehicle.BIKE },
  { country: Country.AE, vehicle: Vehicle.CAR },
  { country: Country.AE, vehicle: Vehicle.BIKE },
  { country: Country.IN, vehicle: Vehicle.CAR },
  { country: Country.IN, vehicle: Vehicle.BIKE },
  { country: Country.AU, vehicle: Vehicle.CAR },
  { country: Country.AU, vehicle: Vehicle.BIKE },
  { country: Country.TH, vehicle: Vehicle.CAR },
  { country: Country.TH, vehicle: Vehicle.BIKE }
],
 */

// TODO: Break down this config module-wise to avoid a monolithic configuration
// List of allowed verticals
const permission = {
  [SHOW_RUNNING_CONDITION]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_PARKING_SLOT]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [SHOW_INVENTORY_TYPE]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_STAGE]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.CAR },
  ],
  [SHOW_CREATED_AT_FILTER]: [{ country: Country.TH, vehicle: Vehicle.CAR }],
  [SHOW_INSPECTION_TAB]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
  ],
  [SHOW_LISTING_PREVIEW_TAB]: [
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_INVENTORY_QR_CODE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_INTERCITY_TAB]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_PIN_CODE_TAB]: [
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_RESERVE_BUTTON]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SPLIT_SLOT_TIME]: [
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.BIKE },
  ],
  [SHOW_BULK_UPLOAD]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
  ],
  [SHOW_INVENTORY_SOURCE]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_SALE_CHANNEL]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_INVENTORY_SOURCE_IN_SEARCH]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SHOW_INVENTORY_SOURCE_TYPE]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_MAKE]: [{ country: Country.IN, vehicle: Vehicle.BIKE }],
  [SHOW_VENDOR_ACTIVE]: [{ country: Country.IN, vehicle: Vehicle.BIKE }],
  [SHOW_LOCATION_MENU]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_MASTER_DATA_MENU]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_BULK_UPLOAD]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_DRIVER_MENU]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [SHOW_TARGET_PRICE]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
  ],
  [C2C_TARGET_PRICE_SHOW]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_OFFER_PRICE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [AVG_MARKET_PRICE_SHOW]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [APPEND_CITY_CODE]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_OFFLINE_DRIVER_TYPES]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
  ],
  [SHOW_TOUCH_POINT_DROPDOWN]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [REMOVE_DEALER_DROPDOWN]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.BIKE },
    { country: Country.ID, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.BIKE },
  ],
  [GET_EXTERNAL_DELIVERY]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SEARCH_INSPECTION_DETAILS]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_CAR_BOOKED_CONFIRMATION]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SHOW_PRICE_LOCK]: [
    { country: Country.KSA, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.BIKE },
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.BIKE },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
    { country: Country.AU, vehicle: Vehicle.BIKE },
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.BIKE },
  ],
  [RESTRICT_DATE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_BROKEN_CAR_MESSAGE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [BLOCK_OUT_DELIVERY]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_OTHER_DETAILS_TAB]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SEARCH_PAYMENT_STATUS]: [{ country: Country.IN, vehicle: Vehicle.BIKE }],
  [USE_SLOT_PLANNER]: [{ country: Country.TH, vehicle: Vehicle.CAR }],
  [SHOW_CORPORATE_OFFICE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_PICKUP_CONTACT_ON_STOCKOUT]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_DA_CONTACT_ON_STOCKOUT]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_PICKUP_CONTACT_ON_PICKUP]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_DA_CONTACT_ON_PICKUP]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_KEY_MANAGEMENT_TAB]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
    { country: Country.KSA, vehicle: Vehicle.CAR },
  ],
  [SHOW_INDIA_KEY_MANAGEMENT_TAB]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SHOW_HOW_TO_REACH]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.BIKE },
  ],
  [SHOW_SOLD]: [
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_STOCKOUT_REASON_FILTER]: [
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [SHOW_REGISTRATION_NUMBER]: [
    { country: Country.TH, vehicle: Vehicle.CAR },
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_ADDRESS_IN_THAI]: [{ country: Country.TH, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_SUBSTAGE]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_STAGE_REMARKS]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_ROUND_TRIP_CHECK]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [HIDE_PINCODE_IN_ADDRESS]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_EDIT_MOVEMENT]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_ROAD_TAX]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_ROAD_TAX_EXPIRY_DATE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_GPS_TRACKER_NO]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_SOURCING_CANCELLATION]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_DEALER_OPTIONAL]: [{ country: Country.TH, vehicle: Vehicle.CAR }],
  [SHOW_PINCODE_FIELD]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [SHOW_PMS_FIELD]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [USE_BACK_DATED_PICKUP]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_LOCUS_ID_IN_OFFLINE_VENDOR]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_REASON_IN_OFFLINE_VENDOR]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_COURTESY_CAR]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_RIDER_PERSONA_ID]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [RESTRICT_ADDRESS_CHAR_COUNT]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SHOW_STOCK_ID]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_PARKED_DATE_FILTER]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_LAST_PARKED_LOCATION_NAME]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_LAST_PARKED_LOCATION_TYPE]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_BULK_ACTION]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_COMMENT_IN_MOVEMENT_CREATION]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_VENDOR_TYPE_FILTER]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_VENDOR_NAME_FILTER]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [DEFAULT_OPEN_INVENTORY_SEARCH]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [DEFAULT_OPEN_LOGISTIC_SEARCH]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [USE_FUZZY_SEARCH_IN_APT_ID]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [USE_FUZZY_SEARCH_IN_VIN]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [USE_FUZZY_SEARCH_IN_STOCK_ID]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [ENABLE_DATE_PICKER_SELECTION_BY_TYPING]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_LOCALITY]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_DELIVERED]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_CONFIGURATIONS_MENU]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_SCHEDULED_TASKS_MENU]: [{ country: Country.TH, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_TYPE_REMARKS]: [
    { country: Country.AE, vehicle: Vehicle.CAR },
  ],
  [SHOW_DP_BANK_STATUS]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_MAPPED_MRL]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_ACCEPTING_INCOMING_LOGISTICS]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SHOW_STORE_IMG_LINK]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
    { country: Country.TH, vehicle: Vehicle.CAR },
  ],
  [SHOW_BARCODE_IN_PARKING_SLOT]: [
    { country: Country.ID, vehicle: Vehicle.CAR },
  ],
  [SHOW_PAYTM_WALLET]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_REGIONAL_PAYTM_FUEL_WALLET]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
  [SHOW_ON_ROAD_PRICE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_MOVEMENT_TYPE_IN_SET_LOGISTICS]: [
    { country: Country.AU, vehicle: Vehicle.CAR },
  ],
  [SHOW_RESERVED_STATUS]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_CUSTOMER_RETURN]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_SERVICEABLE_AREA]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_ORDER_ID]: [{ country: Country.AU, vehicle: Vehicle.CAR }],
  [SHOW_DRIVER_TYPE]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_DRIVER_PAN]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_USER_PREFERENCES_TAB]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_ASSORTMENT_TYPE]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_OFFLINE_DISCOUNT]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_NUMBER_PLATE]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_PARENT_HUB]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_REASON_IN_AUDIT_TRAIL]: [{ country: Country.TH, vehicle: Vehicle.CAR }],
  [SHOW_ADDITIONAL_REASONS]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_CATALOG_FLAG]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_LOCATION_DISPLAY_NAME]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_PSEUDO_STATUS]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_CHASSIS_IMPRINT]: [{ country: Country.IN, vehicle: Vehicle.CAR }],
  [SHOW_UPCOMING_STATUS]: [{ country: Country.AE, vehicle: Vehicle.CAR }],
  [SHOW_INVENTORY_STATUS_REASON]: [
    { country: Country.IN, vehicle: Vehicle.CAR },
  ],
};

export default permission;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
